import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=b285695e&"
import script from "./BaseInputDate.vue?vue&type=script&lang=js&"
export * from "./BaseInputDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports